import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import {Router} from '@angular/router'


@Component({
  selector: 'app-tpaddeditapproval',
  template: require('./tpaddeditapproval.component.html'),
  styles: []
})
export class TPAddEditApprovalComponent implements OnInit {

  expDetails: any;
  private columnDefs;
  private rowData;
  private rowHeight;
  api: any;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;

  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;
  userId: any=0;
  clientType: any=0;
  date: any=null;
  RouteData: any = [];
  TPData:any=[];


  static parameters = [ApiService,Router]

  constructor(
    private apiService: ApiService,
    private router: Router,
  ) {
    let parent = this;
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
      {
        headerName: 'Action', field: 'action', width: 150, cellRenderer: function (params) {
          var eDiv = document.createElement('div');
          eDiv.innerHTML = `
          <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="tpaddedit">
              <label class="custom-control-label" for="tpaddedit"></label>
          </div>
        `;
          return eDiv;
        }
      },
      {
        headerName: 'Employee Name', field: "Client_Name", width: 220, cellRenderer: function (params) {
          var eDiv = document.createElement('div');
          eDiv.innerHTML = `<a class="viewBtn" aria-hidden="true"><i ></i>${params.value}</a>`;
        var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
        viewButton.addEventListener('click', function () {          
          console.log('params data ', params.data);
          // parent.approveTP(params.data);
          
          parent.router.navigate(['addtourprogram'],{ queryParams: { id: params.data.Client_Code,date:params.data.date}});
        });
      
          return eDiv;
        }},
      { headerName: 'Designation ', field: "ClientTypeDesc" },
      { headerName: 'Submit Date ', field: "date" },
      {
        headerName: 'Unlock TP', field: 'unlocktp', width: 120, cellRenderer: function (params) {
          var eDiv = document.createElement('div');
          eDiv.innerHTML = `
          <a href=""><i class="fa fa-edit" aria-hidden="true"></i></a>
        `;
          return eDiv;
        }
      },
      {
        headerName: 'Approve ', field: 'unlocktp', width: 120, cellRenderer: function (params) {
          var eDiv = document.createElement('div');
          eDiv.innerHTML = `
          <a href=""><i class="fa fa-key"></i></a>
        `;
          return eDiv;
        }
      },
      { headerName: 'Status', field: "routredivert" },
      { headerName: 'Approved By', field: "routredivert" },
      { headerName: 'Unlock Reason', field: "routredivert" },
    ];
    this.rowHeight = 50;
    this.defaultColDefine = { resizable: true };
   
  }

  onFirstDataRendered(params) {
    setTimeout(function () {
      params.api.getDisplayedRowAtIndex(1).setExpanded(false);
    }, 0);
  }

  ngOnInit() {
    this.getStaffTypes();
     this.getExpDetails();
    var date = new Date();
    this.currentDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, "0");
    this.currentMonth = this.currentDate;
    console.log('currentDate', this.currentMonth);
  }

  approveTP(item) {
    
    // this.router.navigate(['addtourprogram'],{ queryParams:{item:item} });
    this.router.navigate(['addtourprogram',{ queryParams: { Item: item}}]);
    
    // this.empId = item.data.Client_Code;
    // const url = this.router.serializeUrl(this.router.createUrlTree(['/maptrackingtracking'], { queryParams: { id: item.data.Client_Code, date: item.data.Route_Date } })); window.open(url, '_blank');
  }
  GetTPFilterWise() {
    console.log("filter", this.userId, this.date, this.clientType)
    let data = { userId: this.userId, date: this.date, clientType: this.clientType };
    this.apiService.GetTPFilterWise(data).subscribe((res: any) => {
      this.TPData = res.data;
      // console.log('empDetails', this.expDetails);
    })

  }
  

  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();

  }

  onBtnExport() {
    this.api.exportDataAsCsv({ fileName: 'ExpenseDetail' });
  }
  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
}

  sizeToFit(skipHeader) {
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  getStaffTypes() {
    this.apiService.getStaffTypes().subscribe((res: any) => {
      this.staffTypes = res.data;
      console.log('stafftypes ', this.staffTypes);
    })
  }

  getExpDetails() {
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
        //  console.log('token', token);
        var data = {
            Id: token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
      this.expDetails = res.data;
      console.log('empDetails', this.expDetails);
    })
  }
}
